<template lang="pug">
  div.lmm-content-body-padded
    b-container.d-flex.justify-content-between.mb-2(fluid, v-if="!AppState.isStandalone")
    b-container(fluid, v-if="AppState.isStandalone")
      b-card-group(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            span {{$t('windows')}}
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${agent}/linkmemine_windows_agent_setup.exe`", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manual}/linkmemine_agent_manual_windows_kr.pdf`") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('program')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manager}/linkmemine_windows_manager_setup.exe`", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manual}/linkmemine_admin_manual_pc_cs_kr.pdf`") {{$t('download')}}
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            span {{$t('android')}}
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('program')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="AppState.mobile.Android", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manual}/linkmemine_admin_manual_android_kr.pdf`") {{$t('download')}}
    b-container(fluid, v-else)
      b-card-group(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="brands/windows", scale="2")
            //span {{$t('Windows')}}
            span Windows
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('system-checker')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", href="https://pcclmdm.com/download/tools/PCCLChecker.exe") {{$t('download')}}
      
      b-card-group.mt-2(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="brands/android", scale="2")
            span Android
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} (ACT QC Andrioid 13)
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${android}/act-qc-android-13-pccl-agent.apk`", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} (ACT RK Android 12 GMS)
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${android}/act-rk-android-12-gms-pccl-agent.apk`", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} (PAI Order M50HY-C Android 12)
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${android}/act-tl-android-12-pccl-agent.apk`", download) {{$t('download')}}
      
      b-card-group.mt-2(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="regular/file", scale="2", style="width: 28px;")
            span ETC
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('web')}} {{$t('manager')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manual}/PCCL_Manual.pdf`") {{$t('download')}}
</template>

<script>
import {getCurrentLanguage} from '@/i18n'
export default {
  name: 'downloads-component',
  methods: {
    onWork () {
      this.AppState.$emit('lmm-message-dialog', {
        title: 'LinkMeMine',
        context: {path: 'on_working'}
      })
    }
  },
  data () {
    let lang = getCurrentLanguage()
    if (lang === 'ko') lang = 'kr'
    return {
      agent: `${this.AppState.Path.download}/agent`,
      manager: `${this.AppState.Path.download}/manager`,
      manual: `${this.AppState.Path.download}/manual/${lang}`,
      android: `${this.AppState.Path.download}/agent/android`,
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 0;
  > .card-header {
    border-bottom: 1px solid #D2D2D2;
    font-size: 1.2rem;
    font-weight: 500;
  }
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
  height: 1.3rem;
  width: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
  > svg {
    color: black;
  }
}

.fa-icon {
  position: relative;
  margin-right: 1rem;
  color: #6F6F6F;
}

.download-header span {
  position: relative;
  top: 0.25rem;
}
</style>